<template>
  <div class="">
    <div class="row">
      <div class="col-md-12 col-sm-8">
        <div class="card card-default widget animated">
          <div class="card-heading">
            <form v-on:submit="createSingleUser">
              <div class="col-md-5">
                <h5>Information</h5>
                <br>
                <form-text ref="email" label="Email" name="email" v-model="user.email" validation="required|email"></form-text>
                <form-select ref="role" label = "Role" name="role" v-model="user.role" :options="roles" validation="required"></form-select>
                <br>
                <p>* Note, when user goes to login for the first time they will need to enter their email 
                  then click "Trouble signing in?" in order to reset their password through email. This 
                  ensures password integrity and security for users.
                </p>
              </div>
              <br>
              <div class="col-md-5">
                <div class="form-group">
                    <button type="submit" class="btn btn-success btn-lg">Create</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div><!-- /.col-md-9 -->
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import VueMask from 'v-mask'
import FormText from '../../elements/Form/FormText'
import FormTextArea from '../../elements/Form/FormTextArea'
import FormSelect from '../../elements/Form/FormSelect'
import database from '../../webmaster/Database/database'
import firebase from 'firebase'
import axios from 'axios'

Vue.use(VueMask);
Vue.use(VeeValidate);

export default {
  name: 'createsingleuser',
  components:{
    'form-text':FormText,
    'form-textarea':FormTextArea,
    'form-select':FormSelect
  },
  data () {
    return {
      user: {
        email: '',
        role: '1'
      },
      roles: []
    }
  },
  created:function(){
    this.fetchRoles()
  },
  methods: {
    createSingleUser:function(e){
      e.preventDefault()
      var self = this
      let promises = [];
      for (let child in this.$refs) promises.push(this.$refs[child].$validator.validateAll());
      Promise.all(promises).then(this.$validator.validateAll()).then(() => { 
        // Get a key for a new org.
        firebase.auth().currentUser.getIdToken().then(function(idToken){
          axios.get('https://us-central1-premises-2af49.cloudfunctions.net/app/users/create', {
            headers: { "Authorization": "Bearer " +  idToken},
            params: {
              email: self.user.email,
              role: self.user.role,
              org: self.$store.state.usermain.curOrg.id,
              orgName: self.$store.state.usermain.curOrg.name
            }
          }).then((resp) => {
              console.log(resp);
              self.$router.push('/admin/users')
          }).catch(err => {
              console.log(err);
              self.$swal('Oops...',
                    'An error occured while adding this user!',
                    'error')
          });
        })
      }, () => {});
    },
    fetchRoles: function(){
      this.$bindAsArray('roles', database.getRef('/roles'), null, function(){
        var index = this.roles.indexOf("99");

        this.roles.splice(index, 1);
      });
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// CreateSingleUser.vue?1ef74058